export default class ExtraServicePrice {
	id: any;
	price: number;
	description: string;
	people_max: number;
	people_min: number;
	extra_service_type_id: any;
	extra_service_type_type_id: any;
	// 0/1: la tarifa que el funnel destaca con el chip «Recomendado» (2026-07-24)
	recommended: any;
	// 0/1: M-13 — la tarifa se cobra por DÍA natural del viaje (el motor la
	// multiplica por budgets.days). 0 = precio fijo por persona, como siempre.
	daily: any;
	// 0/1: M-15 — el precio es del GRUPO y se reparte entre los pasajeros (alumnos
	// + profesores). Independiente de `daily`: un acompañante puede ser 90 €/día
	// para todo el grupo. 0 = precio por persona, como siempre.
	group: any;
	// 0/1: N-234 — la tarifa se puede contratar MÁS DE UNA VEZ (el caso es el
	// «Coordinador/a»: hay grupos que necesitan dos). Con el flag encendido, la ficha
	// enseña la cantidad y el presupuesto la guarda en
	// `budgets_extra_services.quantity`. 0 = una sola unidad, como siempre.
	multiple: any;
	// 0/1: N-235 — cada unidad contratada ocupa una PLAZA de profesor de pago (el
	// coordinador viaja con el grupo: cama, comidas y asiento), que el motor cobra con
	// el suplemento del destino y sin pasar por la gratuidad. 0 = solo su precio.
	teacher_seat: any;

	constructor() {
		this.id = null;
		this.price = 0;
		this.description = '';
		this.people_max = 0;
		this.people_min = 0;
		this.extra_service_type_id = null;
		this.extra_service_type_type_id = null;
		this.recommended = 0;
		this.daily = 0;
		this.group = 0;
		this.multiple = 0;
		this.teacher_seat = 0; // nace apagado (decisión 8 de Bernardo)
	}
}
